import React, {useState, useEffect} from "react";
import {connect} from "react-redux";
import axios from "axios";
import {serverLink, paystackAPIKey} from "../../resources/url";
import {formatDateAndTime, imageExists} from "../../resources/constants";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import Header from "../common/header/header";
import logo from "../../images/logo.png";

import {
    applicationFee,
    currencyConverter,
    projectAddress,
    projectName,
    projectURL,
    sendEmail,
    projectshortCode
} from "../../resources/constants";
import PgSidebar from "../common/sidebar/pgsidebar";
function PGApplicationPreview(props) {
    const [userData] = useState(props.applicationLogin);
    const navigate = useNavigate();
    const [canSubmit, setCanSubmit] = useState(true);
    const [requiredDoc, setRequiredDoc] = useState(false);
    const [consent, setConsent] = useState(false)
    // const paystackConfig = {
    //     // reference: (new Date()).getTime().toString(),
    //     email: props.applicant_data.applicant_data[0].EmailAddress,
    //     amount: applicationFee * 100,
    //     publicKey: paystackAPIKey,
    // };
    // you can call this function anything
    const onPaystackSuccess = (reference) => {
        // Implementation for whatever you want to do with reference and after success call.
        //console.log(reference);
        if (reference.status === 'success' && reference.message === 'Approved') {
            toast.info('Submitting your application. Please wait!');
            const sendData = {
                ApplicationID: props.applicationData.EntryID,
                PaymentID: reference.reference,
                StudentID: props.applicationData.EntryID,
                Description: 'Post UTME Fee Payment',
                Amount: 2000
            }

            axios.post(`${serverLink}application/upload/online/payment`, sendData)
                .then(res => {
                    if (res.data.message === 'success') {
                        handleSubmit();
                    }
                })
                .catch(err => {

                })

        }
    };

    // you can call this function anything
    const onPaystackClose = () => {
        // implementation for  whatever you want to do when the Paystack dialog closed.
        //console.log('closed')
    }

    // const PaystackHook = () => {
    //     const initializePayment = usePaystackPayment(paystackConfig);
    //     return (
    //         <div>
    //             <button className="btn btn-dark w-100 active" onClick={() => {
    //                 initializePayment(onPaystackSuccess, onPaystackClose)
    //             }}>Submit Application</button>
    //         </div>
    //     );
    // };

    // useEffect(() => {
    //     let check = false;
    //   props.appRequirement.length > 0 &&
    //     props.appRequirement.map( async (req) => {
    //       if (req.IsRequired === 1) {
    //         let check = props.applicant_data.documents.filter(
    //           (doc) => doc.DocumentType === req.DocumentName
    //         );
    //         if (check.length === 0 || check.length < req.MinDocument) {
    //             console.log('true is here')
    //             check = true;
    //         }
    //       }
    //     });
    //   console.log(check)
    // }, []);

    const handleSubmit = async () => {
        if (props.applicationData.EntryID) {
            toast.info(`Please wait while submitting your application...`);
            await axios
                .patch(
                    `${serverLink}application/pg/update/status/${props.applicationData.EntryID}`
                )
                .then((res) => {
                    if (res.data.message === "success") {
                        toast.success(`Application submitted successfully`);

                              sendEmail(
                                  props.applicant_data.applicant_data[0]?.EmailAddress,
                                  `Application for ${props.applicationData.CourseName}`,
                                  "Application Submitted",
                                  `${props.applicant_data.applicant_data[0]?.FirstName} ${props.applicant_data.applicant_data[0]?.MiddleName} ${props.applicant_data.applicant_data[0]?.Surname}`,
                                  `Thank you for applying for a place in the ${props.applicationData.CourseName} programme. <br/>
                        Provided your application is complete and includes the required documents, we aim to give you a decision on your application by the relevant decision date`,
                                  `Best Regards <br/> Admission Team <br/> <a target="_blank" href=${projectURL}>${projectURL}</a> <br/>,
                                  APP-ID-${props.applicationData.EntryID}`
                              );
                        navigate("/application");
                    } else {
                        toast.error(
                            `Something went wrong. Please check your connection and try again!`
                        );
                    }
                })
                .catch((error) => {
                    console.log("NETWORK ERROR", error);
                });
        }
    };

    let passport = props.applicant_data?.documents?.find(
        (item) => item?.DocumentType?.toLowerCase().includes("passport")
    );
    const allRequiredDocumentsUploaded = props.appRequirement
        .filter(item => item.IsRequired === 1) // Get required documents
        .every(req => props.applicant_data?.document?.some(doc => doc.DocumentType === req.DocumentName));

    useEffect(() => {
        if (
            Array.isArray(props.applicant_data.qualification) &&
            props.applicant_data.qualification.length > 0 &&
            allRequiredDocumentsUploaded
        ) {
            setCanSubmit(true);
        } else {
            setCanSubmit(false);
        }
    }, [props.applicant_data.qualification, allRequiredDocumentsUploaded]);


    const onPrevious = () => {
        navigate("/postgraduate/document-uploads");
    };
    useEffect(() => {
        if (props.applicationLogin.length === 0) {
            navigate("/login");
        }
    }, [props.applicationLogin])
    return (
        // loading ?
        //     <Loader/>
        //     :
        <>
            <div className="main-wrapper">
                <Header/>
                <PgSidebar/>
                <div className="page-wrapper">
                    <div className="content">
                        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                            <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                                <div className="my-auto mb-2">
                                    <h3 className="page-title mb-1">Welcome, {`${userData.FirstName} ${userData.MiddleName} ${userData.Surname}`
                                    }</h3>
                                    <nav>
                                        <ol className="breadcrumb mb-0">
                                            <li className="breadcrumb-item">
                                                <a href="">Dashboard</a>
                                            </li>
                                            <li className="breadcrumb-item active" aria-current="page">Application Preview</li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        <div className="col-10">
                            {canSubmit ? (
                                <>
                                    <div className="pt-3">
                                        <div className="pt-4">
                                            <div className="" style={{ backgroundColor: "#e0e0e0", color: "black", height: "40px", }}>
                                                <h6
                                                    className="pt-2 p-lg-2"
                                                    style={{
                                                        color: "black",
                                                    }}
                                                >
                                                    Personal Information
                                                </h6>
                                            </div>

                                            <div className="row pt-2">
                                                <div className="col-lg-3 col-sm-3">
                                                    {
                                                        <img src={imageExists(`${serverLink}public/uploads/${projectshortCode}/application/document/${passport?.FileName}`)
                                                            ? `${serverLink}public/uploads/${projectshortCode}/application/document/${passport?.FileName}` : logo} height={150} alt="Applicant Passport"/>
                                                    }

                                                </div>
                                                <div className="col-lg-9 col-sm-9">
                                                    <table className="table">
                                                        <tbody>
                                                        <tr>
                                                            <th scope="row">Application ID:</th>
                                                            <td>
                                                                {
                                                                    props.applicationData.EntryID
                                                                }
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Full Name</th>
                                                            <td>
                                                                {props.applicant_data.information?.length > 0 ? (
                                                                    <>
                                                                        {props.applicant_data.information[0].FirstName}{" "}
                                                                        {props.applicant_data.information[0].MiddleName}{" "}
                                                                        {props.applicant_data.information[0].Surname}
                                                                    </>
                                                                ) : (
                                                                    "N/A"
                                                                )}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Phone Number</th>
                                                            <td>
                                                                {props.applicant_data.information?.length > 0
                                                                    ? props.applicant_data.information[0].PhoneNumber
                                                                    : "N/A"}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Gender</th>
                                                            <td>
                                                                {props.applicant_data.information?.length > 0
                                                                    ? props.applicant_data.information[0].Gender
                                                                    : "N/A"}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Email address</th>
                                                            <td>
                                                                {props.applicant_data.information?.length > 0
                                                                    ? props.applicant_data.information[0].EmailAddress
                                                                    : "N/A"}
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <th scope="row">Course Name</th>
                                                            <td>
                                                                {
                                                                    props.applicationData.CourseName
                                                                }
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="pt-3">
                                            <div
                                                className=""
                                                style={{
                                                    backgroundColor: "#e0e0e0",
                                                    color: "black",
                                                    height: "40px",
                                                }}
                                            >
                                                <h6
                                                    className="pt-2 p-lg-2"
                                                    style={{
                                                        color: "black",
                                                    }}
                                                >
                                                    Academic Qualifications
                                                </h6>
                                            </div>

                                            <div className="pt-4 mb-4">
                                                {props.applicant_data.qualification ? (
                                                    <>
                                                        <table className="table table-striped">
                                                            <thead>
                                                            <tr>
                                                                <th>Qualification Title</th>
                                                                <th>Qualification Name</th>
                                                                <th>Awarding Institution</th>
                                                                <th>Grade Obtained</th>
                                                                <th>Date Awarded</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {props.applicant_data?.qualification?.length > 0 &&
                                                                props.applicant_data.qualification.map(
                                                                    (item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{item.QualificationTitle}</td>
                                                                            <td>{item.QualificationName}</td>
                                                                            <td>{item.AwardingInstitution}</td>
                                                                            <td>{item.GradeObtained}</td>
                                                                            <td>{formatDateAndTime(item.DateAwarded, "date")}</td>
                                                                        </tr>
                                                                    )
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="alert alert-info">
                                                            There is no record.
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>


                                        <div className="pt-3">
                                            <div
                                                className=""
                                                style={{
                                                    backgroundColor: "#e0e0e0",
                                                    color: "black",
                                                    height: "40px",
                                                }}
                                            >
                                                <h6
                                                    className="pt-2 p-lg-2"
                                                    style={{
                                                        color: "black",
                                                    }}
                                                >
                                                    Academic Qualifications
                                                </h6>
                                            </div>

                                            <div className="pt-4 mb-4">
                                                {props.applicant_data?.employment ? (
                                                    <>
                                                        <table className="table table-striped">
                                                            <thead>
                                                            <tr>
                                                                <th>Employer</th>
                                                                <th>Employer Address</th>
                                                                <th>Designation</th>
                                                                <th>Start Date</th>
                                                                <th>End Date</th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {props.applicant_data?.employment?.length > 0 &&
                                                                props.applicant_data.employment.map(
                                                                    (item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{item.Employer}</td>
                                                                            <td>{item.EmployerAddress}</td>
                                                                            <td>{item.Designation}</td>
                                                                            <td>{formatDateAndTime(item.StartDate, "date")}</td>
                                                                            <td>{item.IsWorking === '1' ? 'Active' : formatDateAndTime(item.EndDate, "date")}</td>
                                                                        </tr>
                                                                    )
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="alert alert-info">
                                                            There is no record.
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>

                                        <div className="pt-3">
                                            <div
                                                className=""
                                                style={{
                                                    backgroundColor: "#e0e0e0",
                                                    color: "black",
                                                    height: "40px",
                                                }}
                                            >
                                                <h6
                                                    className="pt-2 p-lg-2"
                                                    style={{
                                                        color: "black",
                                                    }}
                                                >
                                                    Document Uploads
                                                </h6>
                                            </div>
                                            {props.applicant_data?.document ? (
                                                <>
                                                    <table className="table table-striped">
                                                        <thead>
                                                        <tr>
                                                            <th>Document Type</th>
                                                            <th>File Name</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {props.applicant_data?.document?.length > 0 &&
                                                            props.applicant_data?.document.map(
                                                                (item, index) => (
                                                                    <tr key={index}>
                                                                        <td>{item.DocumentType}</td>
                                                                        <td>
                                                                            <a
                                                                                target="_blank"
                                                                                referrerPolicy="no-referrer"
                                                                                href={`${serverLink}public/uploads/${projectshortCode}/application/document/${item.FileName}`}
                                                                            >
                                                                                <i className="fa fa-file" />
                                                                            </a>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="alert alert-info">
                                                        There is no record.
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        <div>
                                            <bold>
                                                <b>
                                                    <row>
                                                        <input type="checkbox" onChange={() => setConsent(!consent)} />&emsp;
                                                        <span>“I hereby certify that the information provided in this form is complete, true and accurate
                              to the best of my knowledge.”</span>
                                                    </row>
                                                </b>
                                            </bold>
                                        </div>
                                    </div>
                                    <div className="row mb-5 mt-5 pb-5">
                                        {
                                            // paystackAPIKey !== '' &&
                                            // <div className="col-lg-12">
                                            //     <span className="badge bg-danger text-white">PS: An online payment will popup where you're expected to make a payment of {currencyConverter(applicationFee)} for Post-UTME Screening Fees</span>
                                            // </div>
                                        }

                                        <div className="col-lg-6 col-sm-6 mb-1">
                                            <button
                                                className="btn btn-dark btn w-100 active"
                                                onClick={onPrevious}
                                            >
                                                Previous
                                            </button>
                                        </div>
                                        <div className="col-lg-6 col-sm-6">
                                            {
                                                paystackAPIKey === '' ?
                                                // props.applicant_data.payment_data.length > 0 || paystackAPIKey === '' ? need to add payment to backend
                                                    <button
                                                        className="btn btn-info w-100 active"
                                                        onClick={handleSubmit}
                                                        disabled={consent === false}
                                                    >
                                                        Submit Application
                                                    </button> : ""
                                                // <PaystackHook />
                                            }

                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="alert alert-info">
                                        Form not completed. Kindly complete the application or check the required documents  and come
                                        back to this page for submission
                                    </div>
                                    <div className="col-lg-6 col-sm-6">
                                        <button
                                            className="default-btn btn w-100 active"
                                            onClick={onPrevious}
                                        >
                                            Previous
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                        {/*<div className="row justify-content-center">*/}
                        {/*    <div className="col-md-8 d-flex justify-content-center align-items-center min-vh-50">*/}
                        {/*        <div className="flex-fill">*/}
                        {/*            <br />*/}
                        {/*            */}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<Footer/>*/}
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        applicationLogin: state.loginDetails,
        applicationData: state.applicationDetails,
        applicant_data: state.generalDetails,
        appRequirement: state.ApplicationRequirementDetails,
    };
};
export default connect(mapStateToProps, null)(PGApplicationPreview);
